import { RouterProvider } from 'react-router-dom';
import './App.css';
import { router } from './route/Route';
import Media from './socilaMedia/Media';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <div className="">
      <RouterProvider router={router}></RouterProvider>
      <Toaster/>
      <Media/>
    </div>
  );
}

export default App;
